import { render, staticRenderFns } from "./GenitoresCollapse.vue?vue&type=template&id=06aac9e8&scoped=true&"
import script from "./GenitoresCollapse.vue?vue&type=script&lang=js&"
export * from "./GenitoresCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aac9e8",
  null
  
)

export default component.exports